import { IArtistMutation, IArtistMutationForm } from 'services/artists/types';

export const artistFormToQuery = (artistForm: IArtistMutationForm): IArtistMutation => {
  const {
    id,
    profilePictureLink,
    profilePicturePreviewLink,
    file,
    isBandOption,
    externalIds,
    mainImageId,
    ...artist
  } = artistForm;

  return {
    ...artist,
    artistsInBand: artistForm.isBand
      ? artistForm.artistsInBand.map((artist) => artist.artistId)
      : null,
    phoneNumber: artistForm.phoneNumber?.number
      ? {
          ...artistForm.phoneNumber,
          number: `${artistForm.phoneNumber.number}`,
        }
      : null,
    labelId: artistForm.labelId?.length ? artistForm.labelId : null,
    labelName: artistForm.labelId?.length ? artistForm.labelName : null,
    externalIds: artistForm.externalIds,
    mainImageId: mainImageId || undefined,
  };
};
